angular.module('services.newman.LoginService', [
  'global'
])

/**
 * The LoginService service stores methods used to access
 * system APIs.
 *
 * @class LoginService
 * @constructor
 * @module services.newman.LoginService
 */
.factory('LoginService', [
  '$rootScope',
  '$http',
  '$window',
  'GLOBAL',
  'ModelsService',
  'ApiService',
  function ($rootScope, $http, $window, GLOBAL, ModelsService, ApiService) {
    'use strict';

    var service = {

      apiConfig: {},

      credentials: null,

      token: null,

      userId: null,

      isAuthoring: false,

      /**
       * Sets the configuration on the ApiService
       *
       * @param {string} token - Oath Token
       */
      setToken: function setToken(token) {
        var headers = {
          Authorization: 'Bearer ' + token,
          piSession: localStorage.getItem('piSession')
          //PiSessionId: $window.localStorage.piSession
          //PiSessionId: 'ABC2'
        };

        console.log('token', jwt_decode(token));

        service.token = token;

        ApiService.setConfigHeaders(headers);

        if (!$rootScope.user) {
          service.setUser(jwt_decode(token).uid);
        }

        service.checkToken(token);

        $rootScope.$broadcast('tokenSet');
      },

      setUser: function () {
        service
          .getUser('me')
          .then(function (response) {
            $rootScope.user = response;
            service.checkAuthoring();
            console.log(response);
            return response;
          })
          .catch(function (response) {
            console.log(response);
          });
      },

      getToken: function () {
        return service.token;
      },

      checkAuthoring: function () {
        var ls;
        if ($window.localStorage.newman) {
          ls = JSON.parse($window.localStorage.newman);
          service.isAuthoring = ls.authoring;
        }
        console.log('is authoring', service.isAuthoring);
        return service.isAuthoring;
      },

      /**
       * Checks a token expiration and if less than
       * 10 minutes remaining refreshes
       *
       * @param {string} [token] - JWT token
       */
      checkToken: function checkToken(token) {
        var expiration;
        var refreshStart;
        var currentTime = moment();
        var temporaryToken = token;
        // if token is not set
        if (!temporaryToken) {
          temporaryToken = service.getToken();
        }

        if (temporaryToken) {
          expiration = moment(jwt_decode(temporaryToken).exp, 'X');
          refreshStart = expiration.clone().subtract(10, 'minutes');

          // if token has less than 10 minutes remaining, then refresh
          if (currentTime.isBetween(refreshStart, expiration)) {
            console.log(
              'token refresh',
              refreshStart.format(),
              expiration.format(),
              currentTime.format()
            );

            service.refreshToken(temporaryToken);
          }
        }
      },

      /**
       * Sends login request to server
       *
       * @param {string} [temporaryToken] - JWT token
       * @return {Object} promise
       */
      refreshToken: function refreshToken(temporaryToken) {
        var req;
        var ls;

        if ($window.localStorage.newman) {
          ls = JSON.parse($window.localStorage.newman);
        } else {
          ls = JSON.parse($window.localStorage.newmanhash);
        }

        // refresh token
        req = {
          method: 'GET',
          url: GLOBAL.apiPath + '/auth/token',
          headers: {
            Authorization: 'Bearer ' + temporaryToken,
            piSession: localStorage.getItem('piSession')
          // PiSessionId: $window.localStorage.piSession
          //  PiSessionId: 'ABC3'
          }
        };

        $http(req)
          .then(function (response) {
            if ($window.localStorage.newman) {
              $window.localStorage.newman = JSON
                .stringify({
                  authoring: ls.authoring,
                  user: response.data.userId,
                  token: response.data.token
                });
            } else {
              $window.localStorage.newmanhash = JSON
                .stringify({
                  token: response.data.token
                });
            }

            service.setToken(response.data.token);
            return;
          })
          .catch(function (err) {
            console.log('refresh is busted', err);
          });
      },

      /**
       * Sends login request to server
       *
       * @param {string} email - User's email
       * @param {string} password - User's password
       * @return {Object} promise
       */
      login: function login(email, password) {
        service.credentials = { username: email, password: password };
        return $http.post(GLOBAL.apiPath + '/auth/login', service.credentials);
      },

      /**
       * Removes user information from local storage and memory
       */
      clearUser: function clearUser() {
        console.log('clearUser');
        $window.localStorage.removeItem('newman');
        $window.localStorage.removeItem('newmanhash');
        service.token = null;
        service.credentials = null;
        $rootScope.user = null;
        $rootScope.$broadcast('userLoggedOut');
      },

      /**
       * Uses the provided id to load the logged in user
       *
       * @param {string} id - Key for user
       * @return {Object} Call promise
       */
      getUser: function getUser(id) {
        return ModelsService.get('users', GLOBAL.apiPath + '/users', { id: id });
      },

      changePassword: function changePassword(newpw, verifypw, user) {
        var data = {
          username: user.content.email,
          currentPassword: service.credentials.password,
          newPassword: newpw
        };
        var req = {
          method: 'PUT',
          url: GLOBAL.apiPath + '/auth/passwords/' + user.id,
          headers: {
            Authorization: 'Bearer ' + service.token,
            piSession: localStorage.getItem('piSession')
            //PiSessionId: $window.localStorage.piSession
            //PiSessionId: 'ABC6'
          },
          data: data
        };
        return $http(req);
      }
    };

    return service;
  }
]);
